
export const SEARCH_POST_REQUEST = "SEARCH_PRODUCT_REQUEST";
export const SEARCH_POST_SUCCESS = "SEARCH_PRODUCT_SUCCESS";
export const SEARCH_POST_FAIL = "SEARCH_POST_FAIL";
export const CLEAR_ERRORS = "CLEAR_ERRORS";